import MyHeader from '../../components/header';
import MyFooter from '../../components/footer';
import { auth, db } from '../../firebase';

import Spacer from '../../components/spacer';
import { Form, Link, useLoaderData, useNavigate } from 'react-router-dom';
import l from './mr.module.scss';
import { useEffect } from 'react';
import { getValFrmDict, sdgs, slug } from '../../../k4dAdmin/data';

import { truncateForLink } from '../../data';
const articlesCount = 10;

//getTop5Articles 

export const mostrloader =
  (useApiProviderCtx) =>
  async ({ params, request }) => {
    const { getTop15Articles, getAllSdgPhotos } = useApiProviderCtx;
    let w2 = {};
    try {
      w2 = await getTop15Articles({});
    } catch (e) {}
    let b = await getAllSdgPhotos(params);

    return { ...params, recent: { ...w2 }, photos: { ...b } };
    //return w2;
  };

export default function MostRecent() {
  const { lang, recent, photos } = useLoaderData();
  //const sdg={};
  const navigate = useNavigate();

  return (
    <>
      <MyHeader />
      <div className={l.whole0}>
        <div className={l.whole}>
          <div>
            {/*}
            <Spacer />*/}

            <div className={l.cta2}>
              <h1>Most Recent Contents</h1>
              <a href="#">&nbsp;</a>
            </div>

            <div className={l.mrcCon}>
              <div className={l.mrc}>
                {recent?.data?.map((d, i) => {
                  return (
                    <a
                      key={i}
                      className={l.mrcItem}
                      href={`/${lang}/${d?.key}/${truncateForLink(slug(d?.article_title))}`}
                    >
                      {/*JSON.stringify(d)*/}
                      <img src={photos?.data[d?.primary_tag]?.cover_photo} />
                      <a href={`${d?.primary_tag}`} className={l.primary}>
                        {getValFrmDict(d?.primary_tag)}
                      </a>
                      <div className={l.title}>{d?.article_title}</div>
                      <div className={l.posted}>{new Date(d?.postedOn).toDateString()}</div>
                    </a>
                  );
                })}
              </div>
            </div>
          </div>
          <MyFooter />
        </div>
      </div>
    </>
  );
}
